
import { ApiVersion } from "../const";
import { Company } from "../models/Company";

const getAllCompanies = (token: string) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAllCompanies`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })

}

const newUpdateCompany = (token: string, company: Company) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(company)
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}createCompany/${company.idcompany}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

const updateCompany = (token: string, company: Company) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(company)
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}updateCompany/${company.idcompany}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

const deleteCompany = (token: string, idcompany: number) => {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}deleteCompany/${idcompany}`, requestOptions)
}

const getCompanyInstalations = (token: string, idcompany: number) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getCompanyInstalations/${idcompany}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

const getAllCompanyStates = (token: string, idcompany: number, iniD: string, endD: string) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ iniDate: iniD, finDate: endD })
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAllCompanyStates/${idcompany}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export {
    getAllCompanies,
    newUpdateCompany,
    deleteCompany,
    updateCompany,
    getCompanyInstalations,
    getAllCompanyStates
}